module.exports = __webpack_public_path__ + "img/r2.bc51d0ac.jpg";